import { Component, OnDestroy } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';
import {DataProvider} from "../../providers/data/data";
import {objectAssign} from "@ionic/app-scripts";
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import {OrdersPage} from "../orders/orders";
import {PrintPage} from "../print/print";

/**
 * Generated class for the OrderPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-order',
  templateUrl: 'order.html',
})
export class OrderPage implements OnDestroy {
  selectedItem: any;
  order;
  zoomimg = null;

  constructor(public navCtrl: NavController, public navParams: NavParams, public data: DataProvider, public http: HttpClient, private barcodeScanner: BarcodeScanner, public modalCtrl: ModalController) {
    this.selectedItem = navParams.get('item');
    this.order = Object.assign({}, this.data.orders[this.selectedItem]);
    this.order.artikel = JSON.parse(this.order.artikel);
    for (const artikel of this.order.artikel) {
      const body = {
        token: localStorage.getItem('token'),
        module: 'articles',
        submodule: 'image',
        data: artikel
      };
      this.http.post(environment.api_url, body).subscribe(daten => {
          artikel.image = daten['data'];
          artikel.image_md5 = daten['message'];
        }, error => {
        }
      );
    }
  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad OrderPage');
  }

  ngOnDestroy() {
    this.data.loadList();
  }

  fertigstellen() {
    this.barcodeScanner.scan({torchOn: true}).then((barcodeData) => {
      let scanned_pv = '0';
      if (barcodeData.format === 'QR_CODE') {
        const bstring = barcodeData.text.split('#');
        if (bstring[1] !== undefined) {
          scanned_pv = bstring[1];
        }
      }
      if (barcodeData.format === 'CODE_39') {
        scanned_pv = barcodeData.text;
      }
      if (scanned_pv === this.order.pv_nummer) {
        const body = {
          token: localStorage.getItem('token'),
          module: 'orders',
          submodule: 'item_done',
          data: {id: this.order.id}
        };
        this.http.post(environment.api_url, body).subscribe(daten => {
            if (daten['data'].status === 1) {
              this.order.erledigt++;
            }
            if (daten['data'].status === 2) {
              // this.navCtrl.setRoot(OrdersPage);
              this.order.erledigt++;
            }
          }, error => {
          }
        );
      } else {
        alert('Falscher Barcode ');
      }
    }, (err) => {

    });
  }

  drucken() {
    let profileModal = this.modalCtrl.create(PrintPage, { order: this.order });
    profileModal.present();
    profileModal.onDidDismiss(count => {
      this.order.erledigt = Number(this.order.erledigt) + Number(count);
      this.order.gedruckt = Number(this.order.gedruckt) + Number(count);
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/order/order.ts